/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolLocalShippingIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-local-shipping"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M6.05 20.75Q6.05 20.75 5.36 20.75Q4.67 20.75 3.71 19.79Q2.75 18.82 2.75 17.45L1.68 17.45Q1.13 17.45 0.74 17.06Q0.35 16.68 0.35 16.13L0.35 5.9Q0.35 4.8 1.13 4.03Q1.9 3.25 3 3.25L14.75 3.25Q15.88 3.25 16.64 4.01Q17.4 4.78 17.4 5.9L17.4 7.6L19.55 7.6Q20.18 7.6 20.73 7.86Q21.27 8.13 21.65 8.63L23.38 10.9Q23.5 11.07 23.57 11.28Q23.65 11.47 23.65 11.7L23.65 16.13Q23.65 16.68 23.26 17.06Q22.88 17.45 22.32 17.45L21.35 17.45Q21.35 18.82 20.39 19.79Q19.43 20.75 18.05 20.75Q16.7 20.75 15.75 19.79Q14.8 18.82 14.8 17.45L9.35 17.45Q9.35 18.82 8.39 19.79Q7.42 20.75 6.05 20.75ZM6.05 18.1Q6.05 18.1 6.19 18.1Q6.33 18.1 6.51 17.91Q6.7 17.73 6.7 17.45Q6.7 17.18 6.51 16.99Q6.33 16.8 6.05 16.8Q5.78 16.8 5.59 16.99Q5.4 17.18 5.4 17.45Q5.4 17.73 5.59 17.91Q5.78 18.1 6.05 18.1ZM18.05 18.1Q18.05 18.1 18.19 18.1Q18.32 18.1 18.51 17.91Q18.7 17.73 18.7 17.45Q18.7 17.18 18.51 16.99Q18.32 16.8 18.05 16.8Q17.77 16.8 17.59 16.99Q17.4 17.18 17.4 17.45Q17.4 17.73 17.59 17.91Q17.77 18.1 18.05 18.1ZM17.4 12.75L21.45 12.75L19.55 10.25Q19.55 10.25 19.55 10.25Q19.55 10.25 19.55 10.25L17.4 10.25Z" fill={color} />
    </svg>
  );
}
